import { z } from 'zod';

/** Shared height/weight Zod primitives — mirrors memberFormSchema in healthInsuranceConfig */
export const heightFtZod = () =>
  z
    .union([z.number(), z.string()])
    .transform((val) => {
      if (typeof val === 'string') {
        if (!/^(?!0\d)\d+$/.test(val)) {
          return undefined;
        }
        const num = parseFloat(val);
        return Number.isNaN(num) ? undefined : Math.floor(num);
      }
      return val;
    })
    .refine((val) => val !== undefined && val !== null && val >= 1, {
      message: 'Height (feet) is required',
    })
    .refine((val) => val !== undefined && val <= 8, {
      message: 'Height (feet) cannot be more than 8',
    });

export const heightInchesZod = () =>
  z
    .union([z.number(), z.string()])
    .transform((val) => {
      if (typeof val === 'string') {
        const num = parseFloat(val);
        return Number.isNaN(num) ? undefined : Math.floor(num);
      }
      return val;
    })
    .refine((val) => val !== undefined && val !== null, {
      message: 'Height (inches) is required',
    })
    .refine((val) => val !== undefined && val >= 0, {
      message: 'Height (inches) cannot be negative',
    })
    .refine((val) => val !== undefined && val <= 11, {
      message: 'Height (inches) cannot be more than 11',
    });

export const weightKgZod = () =>
  z
    .union([z.number(), z.string()])
    .transform((val) => {
      if (typeof val === 'string') {
        if (!/^(?!0\d)\d+(\.\d{0,1})?$/.test(val)) {
          return undefined;
        }
        const num = parseFloat(val);
        return Number.isNaN(num) ? undefined : parseFloat(num.toFixed(1));
      }
      return val;
    })
    .refine((val) => val !== undefined && val !== null && val > 0, {
      message: 'Weight is required',
    });
